<template>
  <div class="wrapper">
    <el-dialog
      title="转账支付"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="打款金额" prop="totalAmount">
          <el-input v-model="formData.totalAmount" type="number" disabled />
        </el-form-item>
        <el-form-item label="服务费">
          <el-input v-model="formData.taxPayFee" disabled />
        </el-form-item>
        <el-form-item label="收款方名称">
          <el-input v-model="backData.name" disabled />
        </el-form-item>
        <!-- <el-form-item label="付款时间" prop="createdTime">
          <el-date-picker
            v-model="formData.createdTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          />
        </el-form-item> -->
        <!-- <el-form-item label="流水号" prop="orderNo">
          <el-input v-model="formData.orderNo" @change="value=>{formData.orderNo = value.replace(/\W/g,'')}" />
        </el-form-item>
        <el-form-item label="支付凭证" required>
          <ImgUpload
            :upload-config="{ lebal: '支付凭证', prefix: 'payReceipt', form: formData, suffix: 'Img' }"
          />
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submit">确认打款</el-button>
        </el-form-item>
      </el-form>
      <!-- <vxe-table border height="250" :data="tableData" auto-resize :loading="loading">
        <vxe-table-column field="orderDetailNumber" title="运单号" min-width="260" />
        <vxe-table-column field="amount" title="分配现金" min-width="100" />
        <vxe-table-column field="gmtCreated" title="分配时间" min-width="220" />
      </vxe-table> -->
      <!-- <vxe-pager
        :loading="loading"
        :page-sizes="Pagingconf"
        :current-page.sync="formPage.pageNum"
        :page-size.sync="formPage.pageSize"
        :total="formPage.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      /> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  checkDriverBankCard,
  batchCashPayment,
  batchAlipayPayment,
  loginUserDefaultHousehold,
  remitDefinite
} from "@/api/transport";
import ImgUpload from "@/components/ImgUpload";
export default {
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      }
    },
    isAlipay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      formData: {
        codes: [],
        orderNo: "",
        partyCode: "",
        payeeCode: "",
        payReceiptImg: "",
        createdTime: "",
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      backData: {
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      rules: {
        totalAmount: [
          { required: true, message: "请输入打款金额", trigger: "blur" }
        ]
        // orderNo: [
        //   { required: true, message: "请输入流水号", trigger: "change" },
        //   { max:64, message:'长度不能超过64个字符'}
        // ],
        // createdTime: [
        //   { required: true, message: "请选择时间", trigger: "blur" }
        // ]
      },
      formPage: {
        payTypes: "3,4,5,9,10,11",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0,
        payerRole: 0
      },
      Pagingconf: []
    };
  },
  created() {},
  methods: {
    show() {
      this.formData = Object.assign({}, this.parentData);
      this.findList();
      this.Allocationrecord();
    },
    // 获取/查询 列表
    async findList() {
      if (this.parentData) {
        const rLoading = this.openLoading();
        // let response_l = await loginUserDefaultHousehold({branchCode:this.parentData.branchCode,type:1})
        // if(!response_l.data){
        //   rLoading.close()
        //   this.$message.error('当前机构没有默认公户无法打款')
        //   return
        // }
        let response = await checkDriverBankCard(
          this.parentData.payeeCode,
          this.formData.codes.toString()
        );
        rLoading.close();
        if (!response.data) {
          this.$message.error("当前银企收款人没有绑定银行卡无法打款！");
          return;
        }
        this.dialogVisible = true;
        this.backData = response.data;
        this.formData.platformBank = response_l.data.bankName;
        this.formData.platformCompanyName = response_l.data.companyName;
        this.formData.platformAccount = response_l.data.bankNum;
        this.formData.payeePhone = this.backData.phone;
        this.formData.partyCode = this.backData.partyCode;
      } else {
        this.$message.error("没有选中打款实际承运人！");
        return;
      }
    },
    // 提交
    submit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const paymentApi = this.isAlipay
            ? batchAlipayPayment
            : batchCashPayment;
          let response = await paymentApi(this.formData);
          rLoading.close();
          this.$message.success(response.msg);
          this.$emit("onSuccess");
          this.dialogVisible = false;
        }
      });
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      this.formPage.orderDetailCode = this.formData.codes[0];
      remitDefinite(this.formPage).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.formPage.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.formData.pageNum = currentPage;
      this.formData.pageSize = pageSize;
      this.findList();
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
